<div [formGroup]="group" class="field" [ngClass]="{ hidden: field.hidden }">
    <label for="{{ field.name }}-{{ formId }}" id="label-{{ field.name }}-{{ formId }}" [class.active]="hasFocus">
        <span class="labelcontent fixed">{{ field.label }}<span *ngIf="field.required" class="is-required">*</span></span>
        <ng-container *ngIf="field.description">
            <span class="hint">{{ field.description }}</span>
        </ng-container>
        <div class="selectwrapper">
            <select id="{{ field.name }}-{{ formId }}" [formControlName]="field.name" (focus)="hasFocus = true" (blur)="hasFocus = false">
                <option *ngIf="defaultLabel" value="" [innerHTML]="'hubspot.defaultSelectOptionLabel' | translate"></option>
                <option *ngFor="let item of field.options" [value]="item.value">{{ item.label }}</option>
            </select>
        </div>
    </label>
    <ng-container *ngIf="showErrors$ | async">
        <ng-container *ngFor="let error of group.get(field.name).errors | getIterableErrors">
            <span class="error-msg">{{ getErrorTranslation(error) }}</span>
        </ng-container>
    </ng-container>
    <ng-container *ngFor="let dependentField of field.dependentFieldFilters">
        <ng-container *ngIf="getVisibilityByDependentFieldFiltersAndSetValidators(dependentField, group.get(field.name))">
            <div class="row">
                <ng-container
                    daDynamicField
                    [control]="dependentField.dependentFormField"
                    [reactiveFormData]="group"
                    [formId]="formId"
                ></ng-container>
            </div>
        </ng-container>
    </ng-container>
</div>
